"use strict";

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Factories = _interopRequireWildcard(require("./factories/index.js"));
var _api = _interopRequireDefault(require("./helpers/api.js"));
var _index2 = _interopRequireDefault(require("./actions/index.js"));
var _index3 = _interopRequireDefault(require("./hooks/index.js"));
var Selectors = _interopRequireWildcard(require("./selectors/index.js"));
var _index5 = _interopRequireDefault(require("./reducers/index.js"));
var Constants = _interopRequireWildcard(require("./constants"));
var _index6 = _interopRequireDefault(require("./helpers/index.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n.default = e, t && t.set(e, n), n;
}
var FrontEndContext = /*#__PURE__*/_createClass(function FrontEndContext(_ref) {
  var Bugfender = _ref.Bugfender,
    Config = _ref.Config;
  _classCallCheck(this, FrontEndContext);
  this.Factories = Factories;
  this.Selectors = Selectors;
  this.Reducers = _index5.default;
  this.Constants = Constants;
  this.Helpers = _index6.default;
  this.api = new _api.default(Bugfender, Config);
  this.Config = Config;
  this.Actions = new _index2.default(this.api, this.Config);
  this.Hooks = new _index3.default(this.Actions, this.Config);
});
var _default = exports.default = FrontEndContext;